import moment from 'moment';

export const dateSlide = (baseDate, days) => (baseDate ? moment(baseDate).add(days, 'days') : null);
export const formatDate = date => (date ? moment(date).format('DD/MM/YYYY') : date);
export const formatDateTh = date => (date ? moment(date).format('DD/MM/YYYY') : date);
export const formatDateThWithDash = date => (date ? moment(date).format('DD-MM-YYYY') : date);
export const formatDateJa = date => (date ? moment(date).format('YYYY年MM月DD日') : date);
export const formatYearMonth = date => (date ? moment(date).format('MM/YYYY') : date);
export const formatYear = date => (date ? moment(date).format('YYYY') : date);
export const formatMonth = date => (date ? moment(date).format('M') : date);
export const formatDay = date => (date ? moment(date).format('D') : date);
export const formatDateWithHour = date => (date ? moment(date).format('HH:mm DD/MM/YYYY') : date);
export const formatDateHourJa = date => (date ? moment(date).format('YYYY年MM月DD日 HH:mm') : date);
export const formatDateParam = date => (date ? moment(date).format('YYYY_MM_DD') : date);

export default formatDate;
